export default __webpack_public_path__ + "static/media/print-reports.36e11781.png";